// ImageVariable.ts
import { Node, mergeAttributes } from "@tiptap/core";

export interface DocumentImageVariableOptions {
    HTMLAttributes: Record<string, any>;
}

export const DocumentImageVariable = Node.create<DocumentImageVariableOptions>({
    name: "documentImageVariable",
    group: "inline",
    inline: true,
    atom: true,
    selectable: true,
    draggable: false,

    addAttributes() {
        return {
            name: { default: null },
            label: { default: null },
            src: { default: null },
            alt: { default: null },
            width: { default: "auto" },
            height: { default: "auto" },
        };
    },

    parseHTML() {
        return [
            {
                tag: "img[data-variable-name]",
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return [
            "img",
            mergeAttributes(
                {
                    class: "variable-image",
                    "data-variable-name": HTMLAttributes.name,
                    "data-variable-label": HTMLAttributes.label,
                    src: HTMLAttributes.src ?? "",
                    alt: HTMLAttributes.alt ?? HTMLAttributes.label ?? "",
                    width: HTMLAttributes.width ?? "auto",
                    height: HTMLAttributes.height ?? "auto",
                    contenteditable: "false",
                },
                HTMLAttributes
            ),
        ];
    },
});
